module.exports = __webpack_public_path__ + "media/file-icons/excel-9e50b67e.gif";